// /login — M1 (motiflink §7.5): the admin has no login form. The unified
// sign-in lives in the consumer app; this route just bounces there with a
// redirect back to the dashboard. Kept as a route so every legacy link and
// the _authed gate's 401 target keep working.

import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { appSignInUrl } from '~/lib/auth';

export const Route = createFileRoute('/login')({
  component: LoginRedirect,
});

function LoginRedirect() {
  useEffect(() => {
    window.location.replace(appSignInUrl(`${window.location.origin}/dashboard`));
  }, []);

  return (
    <div className="grid min-h-dvh place-items-center bg-cream-50 p-6">
      <p className="text-sm text-ink-700">Redirecting to sign-in…</p>
    </div>
  );
}
